import {VLineBrush} from './brushes/v-line-brush';

export const BrushTypes = [
    'PencilBrush', 
    'VLineBrush', 
    //'DiamondBrush',
    'HLineBrush', 
    'CircleBrush', 
    'SquareBrush', 
    'SprayBrush',
];

export const BrushSizes = [1, 8, 15, 20, 25];